import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs'

import { AstrolyticsService } from "../../_services/astrolytics.service";
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-recommendations-page',
  templateUrl: './recommendations-page.component.html',
  styleUrls: ['./recommendations-page.component.css']
})
export class RecommendationsPageComponent implements OnInit {

  protected tableData = [];   
  protected data;
  protected loading;   
  protected error; 
    
  recommendationSubscription : Subscription;

  constructor(private astrolyticsService: AstrolyticsService, private authenticationService: AuthenticationService,private route: ActivatedRoute) {             
  }

  ngOnInit() {    
    this.error = false;    
    this.loading = true;
    this.tableData = [];    
    var store_name = this.authenticationService.selectedStoreValue.name       
    this.recommendationSubscription = this.astrolyticsService.recommendationObservable.subscribe( message => {                      
      console.log(message);
        if (message){
          this.data = message;      
          this.tableData = message.recommendations;                        
          this.loading = false;  
          if (message.length == 0){
            this.error = true;
          }          
        }
    });
    this.astrolyticsService.getStoreRecommendations(store_name);        
  }

  ngOnDestroy() {        
    this.recommendationSubscription.unsubscribe();    
    this.data = undefined;
    this.tableData = undefined;        
  }

}
